import React, { Component } from 'react';
import { FontIcon, MenuButton, ListItem } from 'react-md';

export default class TableMenu extends Component {
  render() {
    const { actions, title, index, item, resetSort, resetLotInput } = this.props;
    const inactive = new Date(item.deactivation) < new Date();
    return (
      <MenuButton
        id={`table-menu-button-${index}`}
        className="table-menu-button"
        icon
        simplifiedMenu={false}
        repositionOnScroll={false}
        listStyle={{
          maxHeight: '130px',
          width: '200px',
          backgroundColor: '#FFF',
          border: '1px solid rgba(0, 0, 0, 0.2)',
          boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
          borderRadius: '4px'
        }}
        menuItems={inactive ?
          [
            <ListItem
              key={1}
              id={`people-menu-reactivate-${index}`}
              primaryText="Reactivate"
            />
          ] :
          title === 'People' ?
            [
              <ListItem
                key={1}
                id={`people-menu-send-email-${index}`}
                primaryText="Send Email"
                leftIcon={<FontIcon key="send" children="send" />}
                onClick={() => actions.show({ data: { ...item, email: true }, title: 'sendEmail', edit: true })}
              />,
              <ListItem
                key={2}
                id={`people-menu-edit-${index}`}
                primaryText="Edit"
                leftIcon={<FontIcon key="edit" children="edit" />}
                onClick={
                  () => {
                    resetSort();
                    actions.show({ data: item, title, edit: true });
                  }
                }
              />,
              <ListItem
                key={3}
                id={`people-menu-deactivate-${index}`}
                primaryText="Deactivate"
                leftIcon={<FontIcon key="block" children="block" />}
                onClick={() => actions.showDisable({ data: item, title, action: actions.deactivateUser })}
              />
            ]
            :
            title === 'Organizations' ?
              [
                <ListItem
                  key={1}
                  id={`org-menu-edit-${index}`}
                  primaryText="Edit"
                  leftIcon={<FontIcon key="edit" children="edit" />}
                  onClick={() => {
                    resetSort();
                    actions.show({ data: item, title, edit: true });
                  }}
                />,
                <ListItem
                  key={2}
                  id={`org-menu-deactivate-${index}`}
                  primaryText="Deactivate"
                  leftIcon={<FontIcon key="block" children="block" />}
                  onClick={() => actions.showDisable({ data: item, title, action: actions.deactivateOrg })}
                />
              ]
              :
              [
                <ListItem
                  key={1}
                  id={`lot-menu-edit-${index}`}
                  primaryText="Edit"
                  leftIcon={<FontIcon key="edit" children="edit" />}
                  onClick={() => {
                    resetSort();
                    resetLotInput();
                    actions.show({ data: item, title, edit: true });
                  }}
                />
              ]
        }
        centered
        anchor={{
          x: MenuButton.HorizontalAnchors.INNER_RIGHT,
          y: MenuButton.VerticalAnchors.BOTTOM
        }}
      >
        more_vert
      </MenuButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TableMenu/TableMenu.jsx